import {
	SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT,
	SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DEFAULT_LIGHT,
	SYS_SPACE_FIXED_200,
} from '@oneaudi/unified-web-common';

import styled from 'styled-components';

export const ItemCardStyle = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	border: 1px solid ${SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DEFAULT_LIGHT};
	overflow: hidden;

	img {
		aspect-ratio: 16 / 9;
		object-fit: cover;
		width: 100%;
	}

	&.is-selected {
		border: 2px solid ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT};
	}

	.equipment-content {
		display: flex;
		padding: ${SYS_SPACE_FIXED_200};
		gap: 12px;
		flex-direction: column;
		height: 100%;

		.more-info {
			margin-top: auto;
			width: fit-content;
		}
	}

	.disclaimer-wrapper {
		margin-top: 4px;
	}
	.loading-skeleton {
		position: absolute;
		inset: 0;
		display: grid;
		place-items: center;
		background-color: rgba(255, 255, 255, 0.9);
	}
`;
